<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'settlement.metered.request.businessreasoncode' | translate }}</label>
    <select appSelect [collection]="businessReasonCodeList" formControlName="businessReasonCode">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'settlement.metered.request.meteringpointtype' | translate }}</label>
    <select appSelect [collection]="meteringPointTypeList" formControlName="meteringPointType">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'settlement.wholesale.settlementmethod' | translate }}</label>
    <select appSelect [collection]="settlementMethodList" formControlName="settlementMethod"></select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'settlement.metered.request.product' | translate }}</label>
    <select appSelect [collection]="productList" formControlName="productCharacteristicIdentification">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'settlement.metered.request.startdate' | translate }}</label>
    <input type="date" appInput formControlName="start">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'settlement.metered.request.enddate' | translate }}</label>
    <input type="date" appInput formControlName="end">
  </app-input-group>
</form>
